export const blockIconsCommonactionsTaskAltNew = (
	<span className='material-symbols-outlined'>task_alt</span>
);
